import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import useDarkMode from 'use-dark-mode';
import AppContext from './AppContext';
import MainApp from './MainApp';
import GlobalStyles from './theme/GlobalStyles';
import { lightTheme, darkTheme } from './theme/themes';
import ScrollToTop from './components/ScrollToTop'; // Import du composant


function App() {
  window.matchMedia = null;
  const darkMode = useDarkMode(true);
  const [language, setLanguage] = useState(() => localStorage.getItem('site_language') || 'en');

  useEffect(() => {
    localStorage.setItem('site_language', language);
  }, [language]);

  return (
    <AppContext.Provider value={{ darkMode, language, setLanguage }}>
      <ThemeProvider theme={darkMode.value ? darkTheme : lightTheme}>
        <GlobalStyles />
        <div className="App">
          <BrowserRouter>
          <ScrollToTop />
            <MainApp />
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </AppContext.Provider>
  );
}

export default App;
